import { render, staticRenderFns } from "./editNotifucation.vue?vue&type=template&id=edaeeb24&scoped=true&"
import script from "./editNotifucation.vue?vue&type=script&lang=js&"
export * from "./editNotifucation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edaeeb24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edaeeb24')) {
      api.createRecord('edaeeb24', component.options)
    } else {
      api.reload('edaeeb24', component.options)
    }
    module.hot.accept("./editNotifucation.vue?vue&type=template&id=edaeeb24&scoped=true&", function () {
      api.rerender('edaeeb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/zxx/components/home-page/editNotifucation.vue"
export default component.exports